var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3689_78981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3689_78981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 18.8333C4.54036 18.8333 4.148 18.6701 3.82161 18.3437C3.49523 18.0173 3.33203 17.625 3.33203 17.1666V8.83331C3.33203 8.37498 3.49523 7.98262 3.82161 7.65623C4.148 7.32984 4.54036 7.16665 4.9987 7.16665H5.83203V5.49998C5.83203 4.3472 6.23828 3.36456 7.05078 2.55206C7.86328 1.73956 8.84592 1.33331 9.9987 1.33331C11.1515 1.33331 12.1341 1.73956 12.9466 2.55206C13.7591 3.36456 14.1654 4.3472 14.1654 5.49998V7.16665H14.9987C15.457 7.16665 15.8494 7.32984 16.1758 7.65623C16.5022 7.98262 16.6654 8.37498 16.6654 8.83331V17.1666C16.6654 17.625 16.5022 18.0173 16.1758 18.3437C15.8494 18.6701 15.457 18.8333 14.9987 18.8333H4.9987ZM4.9987 17.1666H14.9987V8.83331H4.9987V17.1666ZM9.9987 14.6666C10.457 14.6666 10.8494 14.5035 11.1758 14.1771C11.5022 13.8507 11.6654 13.4583 11.6654 13C11.6654 12.5416 11.5022 12.1493 11.1758 11.8229C10.8494 11.4965 10.457 11.3333 9.9987 11.3333C9.54036 11.3333 9.148 11.4965 8.82161 11.8229C8.49523 12.1493 8.33203 12.5416 8.33203 13C8.33203 13.4583 8.49523 13.8507 8.82161 14.1771C9.148 14.5035 9.54036 14.6666 9.9987 14.6666ZM7.4987 7.16665H12.4987V5.49998C12.4987 4.80554 12.2556 4.21526 11.7695 3.72915C11.2834 3.24304 10.6931 2.99998 9.9987 2.99998C9.30425 2.99998 8.71398 3.24304 8.22786 3.72915C7.74175 4.21526 7.4987 4.80554 7.4987 5.49998V7.16665Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5eccd7af5c4924e7bbfabb03f6a84ff8.svg";
export { ForwardRef as ReactComponent };